<template>
    <div class="flex-column-between">
          <div  style="padding: 17px 15px 0 15px;">
              <div class="text">帮扶课程</div>
              <div style="width: 100%" class="table-container">
                <el-table
            :data="tableData"     

            style="width: 100%;font-size: 20px;"
            :default-sort = "{prop: 'date', order: 'descending'}"
            height="100%" 
            >
            <el-table-column prop="lessons" label="课程名称" fixed   header-align="center" align="center"></el-table-column>
            <el-table-column prop="teacher" label="教师名称"  header-align="center" align="center"></el-table-column>
            <el-table-column prop="helping" label="正在帮扶人数"   header-align="center" align="center"></el-table-column>
            <el-table-column prop="notup" label="未达标人数"  header-align="center" align="center" ></el-table-column>
            <el-table-column
              fixed="right"
              label="详情"
               header-align="center" align="center"
              >
              <template slot-scope="scope">       
                <el-button type="text" size="small" @click="detail()">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
              </div>
  
          </div>

    </div>  
    </template>
    
    <script>
  
    export default {
      components: {
        
      },
      data() {
        return {
            tableData: [{
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },
        {
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },
        {
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },
        {
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },
        {
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },
        {
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },

        {
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },{
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },
        {
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },
        {
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },
        {
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },
        {
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },
        {
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },
        {
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },
        {
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },

        {
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },{
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },
        {
                lessons: '电路分析',
                teacher: '王小虎',
                helping: '20',
                notup: '3',
        },

      
    
    ]
        }
      },
      methods:{
        detail(){
            this.$router.push({path:'/alllessions'})
        }
      }
    }
    </script>
    
    <style scoped>

  .text{
  margin-top: 15px;
  font-size: 22px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 31.86px;
  color: rgba(51, 51, 51, 1);
  }
/* 强制覆盖 Element UI 默认边框 */
.no-border-table.el-table,
.no-border-table.el-table th,
.no-border-table.el-table td,
.no-border-table.el-table tr,
.no-border-table.el-table::before,
.no-border-table.el-table::after,
.no-border-table .el-table__fixed-right::before,
.no-border-table .el-table__fixed::before {
  border: none !important;
  border-bottom: none !important;
  border-right: none !important;
}

.no-border-table .el-table__header-wrapper th {
  border-bottom: none !important;
}

.no-border-table .el-table__cell {
  border: none !important;
}
/* 表格容器样式 - 关键 */
.table-container {
  height: 40vh; /* 设置固定高度或使用 calc(100vh - 其他元素高度) */
  overflow: hidden; /* 隐藏外部滚动 */
}

/* 表格样式调整 */
.el-table {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 表头固定 */
.el-table__header-wrapper {
  position: sticky;
  top: 0;
  z-index: 10;
}

/* 表格内容区域滚动 */
.el-table__body-wrapper {
  overflow-y: auto !important;
  flex: 1;
}

/* 滚动条美化 */
.el-table__body-wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 3px;
}
    </style>